import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';
import { IBatchListItem } from '../interfaces/gisSource';

@Pipe({ name: 'latestGisImport' })
export class LatestGisImportPipe implements PipeTransform {
  transform(value: IBatchListItem[], ...args: unknown[]): IBatchListItem | null {
    if (value.length) {
      const [latestImport] = orderBy(value, (_import) => _import.created, 'desc');
      return latestImport;
    }
    return null;
  }
}
